import { constants, ObjectId } from 'lib_ui-services';
import lodash from 'lodash';
const { cloneDeep } = lodash;

const { useCaseIds } = constants;

export default {
    verb: 'willNew',
    namespace: 'item',
    relation: 'item',
    priority: 30,
    prerequisites: [],
    description: 'Add missing _id to new item record foreign key fields',
    useCaseIds: [useCaseIds.ASSET_TRACKING, useCaseIds.RFID],
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @template {{ newRecord: { [key: string]: any } }} T
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {Promise<T>}
 */
async function logic({ data, context, dispatch }) {
    const newRecord = cloneDeep(data.newRecord);
    // check all the properties of the newRecord object
    // if the key contains a colon, and the value does not have an _id property
    // Find the appropriate database record, or create a new one if it does not exist

    // This is primarily for SGTIN-sourced new item records.
    // the (titles on) foreign keys get generated from the SGTIN, but it does not look up the _ids at that time.
    for (const key in newRecord) {
        if (key.includes(':') && newRecord[key] && !newRecord[key]._id) {
            // Split the key to get the namespace and relation
            const [ns, rel] = key.split(':');
            const response = await dispatch(
                {
                    query: { title: newRecord[key].title }
                },
                {
                    ...context,
                    verb: 'get',
                    namespace: ns,
                    relation: rel,
                    type: 'find'
                },
                // awaitResult
                true
            );
            if (response?.result?.length) {
                const result1 = response.result[0];
                newRecord[key]._id = result1._id;
            } else {
                // If no record is found, we need to create a new one
                const newForeignRecord = {
                    _id: ObjectId(),
                    ...newRecord[key]
                };
                let createContext = {
                    verb: 'create',
                    namespace: ns,
                    relation: rel
                };
                await dispatch({ newRecord: newForeignRecord }, createContext, true);
                // After creating, we assign the new _id to the newRecord
                newRecord[key]._id = newForeignRecord._id;
            }
        }
    }

    // include the updated newRecord in the data before passing it to the getOfflineAction method
    data.newRecord = newRecord;
    return data;
}
